<template>
  <div class="wrapper" style="overflow-x: hidden">
    <div class="head">
      <div class="head_title">了解我们的产品</div>
      <div class="head_title_2">上海新纪元教育 慧学堡@精准学教</div>
      <div class="head_video_box">
        <div class="head_video_box_head">
          功能介绍视频 <span> 点击查看功能操作详情</span>
        </div>
        <div class="head_video_box_item">
          <el-carousel
            :interval="5000"
            arrow="always"
            class="head_video_box_item"
          >
            <el-carousel-item
              v-for="(item, index) in data"
              :key="index"
              class="head_video_box_item"
            >
              <a
                :href="'https://www.gaokaowin.com' + item.video"
                target="_blank"
                style="color: #666; poistion: relative"
              >
                <img
                  class="head_video_box_head_video_img"
                  :src="'https://www.gaokaowin.com' + item.image"
                  alt=""
                />
                <div class="video_nama">{{ item.name }}</div>
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in appList" :key="index" class="app_list">
      <div class="app_img">
        <img
          :class="{ app_img_img_mobile: index == 5 }"
          :src="item.img"
          alt=""
        />
      </div>
      <div class="app_right">
        <div class="app_right_title_box">
          <div><img v-if="item.icon" :src="item.icon" alt="" /></div>
          <div class="app_right_title">
            {{ item.name }}
          </div>
        </div>
        <div class="app_right_content">{{ item.content }}</div>
        <div class="app_right_box">
          <div v-if="index == 0" @click="$router.go(-1)">点击进入</div>
          <div v-if="index != 0"><a :href="item.appUrl">点击下载</a></div>
          <div>
            <a :href="item.appApi" v-if="index != 3"> 下载操作说明手册</a>
          </div>
        </div>
        <div class="app_right_box_chorme" v-if="index == 0">
          <div>推荐使用浏览器：</div>
          <div>
            <img src="../../assets/images/downLoad/chrome-logo.png" alt="" />
          </div>
          <div>chrome浏览器</div>
          <div class="app_right_box_chorme_down">
            <a target="_blank" href="http://www.google.cn/chrome/">点击下载</a>
          </div>
        </div>
        <div class="app_right_box_chorme" v-if="index == 0">
          <div>远程控制软件：</div>
          <div>
            <img
              src="https://img2.baidu.com/it/u=1867187693,3692720125&fm=26&fmt=auto&gp=0.jpg"
              alt=""
            />
          </div>
          <div>向日葵</div>
          <div class="app_right_box_chorme_down">
            <a target="_blank" href="https://sunlogin.oray.com/download/"
              >点击下载</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "downLoad",
  data() {
    return {
      video_src: "",
      data: [],
      appList: [
        {
          name: "慧学堡-教师PC端",
          icon: "",
          content:
            "专为老师设计的教学工具，只需简单的操作，老师即可将想法展现于眼前。",
          img: "https://www.gaokaowin.com/download/help/teacher_pc2.0.png",
          appUrl: "",
          appApi: "https://www.gaokaowin.com/download/help/慧学堡教师PC端.docx",
        },
        {
          name: "慧学堡-教师端APP",
          icon: "https://www.gaokaowin.com/download/help/teacher_logo.png",
          content:
            "常态化智慧课堂工具，便捷地反转学习，参与式课堂互动，全方位学习数据，轻松实施互动教学及翻转式学习的课堂模式。",
          img: "https://www.gaokaowin.com/download/help/teacher_app.png",
          appUrl: "https://www.gaokaowin.com/download/teacher.apk",
          appApi: "https://www.gaokaowin.com/download/help/慧学堡教师Pad端.doc",
        },
        {
          name: "慧学堡-学生端APP",
          icon: "https://www.gaokaowin.com/download/help/student_logo.png",
          content:
            "常态化智慧课堂工具，便捷地反转学习，参与式课堂互动，全方位学习数据，轻松实施互动教学及翻转式学习的课堂模式。",
          img: "https://www.gaokaowin.com/download/help/student_app.png",
          appUrl: "https://www.gaokaowin.com/download/student.apk",
          appApi:
            "https://www.gaokaowin.com/download/help/慧学堡学生Pad端.docx",
        },
        {
          name: "小手牵小手",
          icon: "https://www.gaokaowin.com/download/help/xsqxs_logo.png",
          content: "做慈善事业的行动者，当爱心奉献的传播者。",
          img: "https://www.gaokaowin.com/download/help/xsqxs_app.jpg",
          appUrl: "https://www.gaokaowin.com/download/xsqxs_student.apk",
          appApi: "",
        },
        {
          name: "新纪元会议exe",
          icon: "https://www.gaokaowin.com/download/help/xjy_logo.png",
          content:
            "助您轻松实现远程会议、远程培训和异地协作办公等。支持丰富的多媒体教学和课件管理，可实现多方互动、全网直播等教学模式。",
          img: "https://www.gaokaowin.com/download/help/xjy_exe.png",
          appUrl: "http://shuangshi.gaokaowin.com/download/HighClassRoom.exe",
          appApi:
            "https://www.gaokaowin.com/download/新纪元会议电脑端使用说明.docx",
        },
        {
          name: "新纪元会议APP",
          icon: "https://www.gaokaowin.com/download/help/xjy_logo.png",
          content:
            "助您轻松实现远程会议、远程培训和异地协作办公等。支持丰富的多媒体教学和课件管理，可实现多方互动、全网直播等教学模式。",
          img: "https://www.gaokaowin.com/download/help/xjy_app.png",
          appUrl: "http://shuangshi.gaokaowin.com/download/meeting.apk",
          appApi:
            "https://www.gaokaowin.com/download/新纪元会议app手机端操作说明.docx",
        },
        {
          name: "慧学堡云聊APP",
          icon: "https://www.gaokaowin.com/download/help/yunliao_logo.png",
          content:
            "架起家长与教师之间点对点沟通的桥梁。",
          img: "https://www.gaokaowin.com/download/help/yunliao_app.png",
          appUrl: "https://yunliao.gaokaowin.com/download/yunliao.apk",
          appApi:
            "https://www.gaokaowin.com/download/慧学堡云聊app操作说明.docx",
        },
      ],
    };
  },
  computed: {
    getDate() {
      return Date.parse(new Date());
    },
  },
  mounted() {
    this.getVideoList();
  },
  methods: {
    toLogin() {
      this.$router.go(-1);
    },
    getVideoList() {
      this.axios
        .post("https://www.gaokaowin.com/teacher/subject/gethelpvideo")
        .then((res) => {
          // this.data=res.data.data
          // let data={pc_teacher:[],app_teacher:[],app_student:[],pc_pc:[]}
          // for(let i in res.data.data){
          //   if(res.data.data[i].category==1){
          //     data.pc_teacher.push(res.data.data[i])
          //   }
          //   if(res.data.data[i].category==2){
          //     data.app_teacher.push(res.data.data[i])
          //   }
          //   if(res.data.data[i].category==3){
          //     data.app_student.push(res.data.data[i])
          //   }
          //   if(res.data.data[i].category==4){
          //     data.pc_pc.push(res.data.data[i])
          //   }
          // }
          this.data = res.data.data;
          console.log(this.data);
        });
    },
    openVideo(data) {
      console.log(data);
      window.location.href = data.video;
      // this.video_src=data.video
    },
  },
};
</script>
<style >
.head_video_box_item .el-carousel__container {
  height: 640px;
}
.head_video_box_item .el-carousel__arrow--left {
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.5);
}
.head_video_box_item .el-carousel__arrow--right {
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.5);
}
</style>

<style scoped >
.head {
  height: 1080px;
  background: url("../../assets/images/downLoad/背景.png");
  background-size: cover;
  text-align: center;
  overflow: hidden;
}
.head_title {
  height: 36px;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #00162c;
  line-height: 36px;
  margin-top: 69px;
  margin-bottom: 20px;
}
.head_title_2 {
  height: 22px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4474a3;
  line-height: 22px;
  margin-bottom: 170px;
}
.head_video_box {
  width: 1256px;
  margin: 0 auto;
}
.head_video_box_head {
  height: 30px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #00162c;
  line-height: 30px;
  text-align: left;
  margin-bottom: 20px;
}
.head_video_box_head > span {
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4474a3;
}
.head_video_box_head_video_img {
  width: 100%;
  height: 640px;
}
.head_video_box_item {
  height: 640px;
  border-radius: 20px;
  overflow: hidden;
}
.video_nama {
  position: absolute;
  bottom: 0;
  height: 82px;
  background: #000000;
  opacity: 0.5;
  border-radius: 0px 0px 20px 20px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 82px;
  width: 100%;
  text-align: left;
  text-indent: 28px;
}
.app_list {
  padding: 266px 360px;
  background: white;
  display: flex;
  justify-content: space-between;
  text-align: left;
}
.app_list:nth-of-type(2n-1) {
  background: rgba(86, 171, 255, 0.35);
}
.app_img img {
  width: 554px;
  height: 337px;
}
.app_img_img_mobile {
  width: 386px !important;
  height: 630px !important;
}
.app_img {
  margin-right: 60px;
  flex: 1;
}
.app_right {
  flex: 1;
  margin-left: 60px;
  margin-top: 20px;
}
.app_right_title_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.app_right_title_box img {
  display: block;
  width: 50px;
  height: 50px;
  margin-right: 33px;
}
.app_right_title {
  height: 33px;
  font-size: 33px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #00162c;

  line-height: 33px;
}
.app_right_content {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #00162c;
  line-height: 30px;
  margin-bottom: 30px;
}
.app_right_box {
  display: flex;
  align-items: center;
}
.app_right_box > div:nth-of-type(1) {
  height: 66px;
  background: #69b4ff;
  border-radius: 8px;
  padding: 0 20px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 66px;
  cursor: pointer;
}
.app_right_box > div:nth-of-type(1) a {
  color: white !important;
}
.app_right_box > div:nth-of-type(2) {
  height: 22px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-left: 33px;
  cursor: pointer;
}
.app_list:nth-of-type(2n-1) .app_right_box > div:nth-of-type(1) {
  background: white;
  color: #00162c;
}
.app_list:nth-of-type(2n-1) .app_right_box > div:nth-of-type(1) a {
  color: #00162c !important;
}

.app_right_box a {
  color: #999999;
}

.app_right_box_chorme {
  display: flex;
  align-items: center;
  height: 56px;
  line-height: 56px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #00162c;
  margin-bottom: 20px;
}
.app_right_box_chorme img {
  display: block;
  height: 30px;
  width: 30px;
  margin: 0 10px;
}
.app_right_box_chorme_down {
  height: 56px;
  background: #69b4ff;
  border-radius: 8px;
  line-height: 56px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;

  margin-left: 20px;
  cursor: pointer;
}
.app_right_box_chorme_down a {
  color: white !important;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0 20px;
}

/* 386 630  */
</style>
